import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'intersection-observer';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {detect} from 'detect-browser';
import {ThemeProvider} from '@emotion/react';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux';
import {assertExists} from 'wnd-util/lib/assert';
import {GlobalStyles} from '>styles/globalStyles';
import {store} from './store/main';
import {routes} from './routes/routes';
import './i18n';
import {I18nextProvider, useTranslation} from 'react-i18next';
import {defaultTheme} from 'wnd-themes/lib/defaultTheme';

const MainApplication: React.FC = () => {
  const {i18n} = useTranslation();

  return (
    <ThemeProvider theme={defaultTheme}>
      <GlobalStyles />
      <I18nextProvider i18n={i18n}>
        <App routes={routes} />
      </I18nextProvider>
    </ThemeProvider>
  );
};

function applyBrowserClass(element: HTMLElement) {
  const browserInfo = detect();

  element.className = browserInfo?.name ?? 'unknown-browser';
}

const rootElement = document.getElementById('root');

assertExists(rootElement, 'must have element with id "root"');

applyBrowserClass(rootElement);

ReactDOM.render(
  <Provider store={store}>
    <MainApplication />
  </Provider>,

  rootElement
);

// If you want your app to work offline and load faster, you can change

// unregister() to register() below. Note this comes with some pitfalls.

// Learn more about service workers: https://bit.ly/CRA-PWA

serviceWorker.unregister();
